import { render, staticRenderFns } from "./DxBatchesTable.vue?vue&type=template&id=dd135a72&"
import script from "./DxBatchesTable.vue?vue&type=script&lang=js&"
export * from "./DxBatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./DxBatchesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports